import { GetStaticProps } from "next"
import { Box, Container, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import Image from "next/image"

import fetchLockProducts, {
	FormattedLockProduct,
} from "utils/commerceTools/graphql/queries/fetchLockProducts"
import { anonymousAccessTokenCache } from "@secureo/common/utils/commerceTools/token/accessTokenCache"
import serializeJSON from "@secureo/common/utils/serializeJSON"

import DownloadItem from "containers/Manuals/DownloadItem"
import SEO from "components/SEO"

import BackgroundImage from "/images/schlossuebersicht.png"

const useStyles = makeStyles()(() => ({
	headerBgImage: {
		position: "absolute",
		top: 0,
		right: 0,
		height: "650px",
		width: "50vw",
		overflow: "hidden",
		zIndex: 0,
		filter: "brightness(100%)",
		"@media only screen and (max-width: 960px)": {
			filter: "brightness(60%)",
			width: "90vw",
			opacity: 0.4,
		},
	},
	headerText: {
		maxWidth: 500,
		"@media only screen and (max-width: 960px)": {
			maxWidth: "100%",
		},
	},
}))

const ManualsPage = ({ locks }: Props) => {
	const { classes } = useStyles()

	return (
		<>
			<SEO
				asPath={"/manuals"}
				title="Bedienungsanleitungen"
				appendLocalizedShopNameWithPipe
			/>

			<div style={{ backgroundColor: "#182F37", minHeight: "600px", color: "white" }}>
				<div className={classes.headerBgImage}>
					<Image
						alt="Kontakt"
						src={BackgroundImage}
						quality={100}
						fill
						sizes="100vw"
						style={{
							objectFit: "cover",
						}}
					/>
				</div>
				<Container>
					<Box pt={20} pb={5} className={classes.headerText}>
						<div style={{ color: "#009CAC" }}>
							Ein Übersicht unserer Tresorschlösser sowie…
						</div>
						<h1 style={{ fontWeight: 100, letterSpacing: 0.5 }}>
							Bedienungsanleitungen für Ihr Tresorschloss
						</h1>
						<p>
							Hier können Sie die Bedienungsanleitung Ihres Tresorschlosses bequem als
							PDF-Datei herunterladen
						</p>
					</Box>
				</Container>
			</div>
			<Box pb={5} style={{ backgroundColor: "#182F37", color: "#fff", paddingTop: 50 }}>
				<Container>
					{locks.map((lock) => {
						const { id, name, attributes, images, assets } = lock
						const image = images?.[0]
						const { shortDescription } = attributes

						const url = assets?.[0]?.sources?.[0]?.uri ?? ""

						return (
							<Box mb={10} key={id}>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<h2 style={{ textAlign: "center", fontWeight: 100 }}>
											{name}
										</h2>
									</Grid>
									{/* <Grid item xs={12} md={4}></Grid> */}
									<Grid
										item
										xs={12}
										md={6}
										style={{
											textAlign: "center",
											display: "flex",
											justifyContent: "center",
										}}
									>
										{image && (
											<div
												style={{
													position: "relative",
													width: "100%",
													minHeight: 200,
													maxHeight: 250,
													maxWidth: 300,
													marginLeft: "auto",
													marginRight: "auto",
												}}
											>
												<Image
													alt={name}
													src={image}
													quality={100}
													fill
													sizes="100vw"
													style={{
														objectFit: "contain",
													}}
												/>
											</div>
										)}
									</Grid>
									<Grid item xs={12} md={6}>
										<div>
											<strong>Auf einen Blick</strong>
										</div>
										{shortDescription && (
											<p
												dangerouslySetInnerHTML={{
													__html: shortDescription,
												}}
											/>
										)}
										<DownloadItem name={name} url={url} />
									</Grid>
								</Grid>
							</Box>
						)
					})}
				</Container>
			</Box>
		</>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const accessToken = await anonymousAccessTokenCache()
	const locale = context.locale as string

	const locks = await fetchLockProducts(accessToken)

	const props = {
		locale,
		locks,
	}

	return serializeJSON({ props })
}

interface Props {
	locale: string
	locks: FormattedLockProduct[]
	name: string
}

export default ManualsPage
